export default "__VITE_ASSET__vGk8Klj1__"